exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-title[data-v-1c27ddde]{width:100%;text-align:center\n}", ""]);

// exports
